const googleAds = {
  googleAds: 'Отчет о рекламе',
  showing: 'Показывается',
  googleAdsOf: 'записи',
  noGoogleAdsFound: 'Записи не найдены',
  addNewRecords: 'Добавить новые записи',
  successfullyAdded: 'Все записи успешно добавлены',
  delete: 'Удалить',
};
export default googleAds;
